import React from 'react';
import { handleNewTabLink } from '../../services/Utils';
const DefaultEventCard = (props) => {

    const handleClick = (e) => {
        handleNewTabLink(e, props.target, props.url);
    }

    return (
        <article className="card post" onClick={handleClick}>

            <a href={props.url} target={props.target}>

                <div className="image">

                    <img src={props.image} alt="" />

                </div>

            </a>

            <div className="content">

                <a href={props.url} target={props.target}>

                    <h6 dangerouslySetInnerHTML={{ __html: props.title }}></h6>

                    <div className="event-date">{props.date}</div>

                </a>

            </div>

        </article>
    );

}

export default DefaultEventCard;

/*
<article class="card  post">

    <a href="http://church.test/2018/01/07/fcc-team-bash/">

        <div class="image">

            <img src="http://church.test/wp-content/uploads/2018/10/FCC-Team-Bash-Final-1-545x310.jpg">

        </div>

        </a><div class="content"><a href="http://church.test/2018/01/07/fcc-team-bash/">

            <h6>FCC Team Bash</h6>


                <div class="excerpt">FCC is celebrating service by honoring all our folks who “Serve on the team.” All team members are encouraged to join us for a...</div>

                </a><div class="author"><a href="http://church.test/2018/01/07/fcc-team-bash/">

    </a><div class="author-profile-picture"><a href="http://church.test/2018/01/07/fcc-team-bash/">

        </a><div class="author-profile-picture"><a href="http://church.test/2018/01/07/fcc-team-bash/">

            </a><a href="http://church.test/people/tommy-staggs/"><img src="http://church.test/wp-content/themes/church-emphasis/assets/dist/img/default-avatar.jpg"></a>

        </div>

    </div>

</div>



        </div>





</article>*/
